@if (functionOption) {
    <div class="function-container d-flex flex-column">
    <div class="view">
        <!-- Tabs -->
        <mat-tab-group (selectedTabChange)="onTabChange($event)" [selectedIndex]="selectedIndex">
            <mat-tab [disabled]="true">
                <ng-template mat-tab-label>
                    <div class="tab-header-label">
                        <span class="category"><small>Feed</small></span>
                        <span class="object-name">{{ functionOption.name }}</span>
                    </div>
                </ng-template>
                <!-- No content required -->
            </mat-tab>
            <mat-tab label="Overview">
                <div class="tab-content">
                    <h3>Function Overview</h3>
                    <p><strong>Name:</strong> {{ functionOption.name }}</p>
                    <p><strong>Description:</strong> {{ functionOption.description }}</p>
                    <p><strong>Enabled:</strong> {{ functionOption.enabled ? 'Yes' : 'No' }}</p>
                    <p><strong>Type:</strong> {{ functionOption.type }}</p>
                    @if (functionOption.type === 'Email') {
                        <p><strong>Recipient:</strong> {{ functionOption.emailRecipients?.[0]?.email }}</p>
                        <p><strong>Subject:</strong> {{ functionOption.emailSubjectTemplate }}</p>
                    } @else {
                        <p><strong>Endpoint:</strong> {{ functionOption.endpoint || 'Not configured' }}</p>
                        @if (functionOption.endpointCredentialConfigured) {
                            <p><strong>Endpoint credential:</strong> Configured (redacted)</p>
                        }
                        <p><strong>Bearer credential:</strong> {{ functionOption.bearerKey ? 'Configured (redacted)' : 'Not configured' }}</p>
                    }
                    <p><strong>Wait Message:</strong> {{ functionOption.waitMessage }}</p>
                    <p><strong>Updated Date:</strong> {{ functionOption.updatedDate | date:'short' }}</p>
                    <p><strong>Parameters:</strong></p>
                    <pre>{{ functionOption.parameters }}</pre>
                </div>
            </mat-tab>
            <!-- Settings Tab -->
            <mat-tab label="Settings">
                <div class="tab-content">
                    <app-client-object-settings [clientSettingsForm]="settingsForm"
                                                [object]="functionOption"></app-client-object-settings>
                    <app-function-general-settings
                        [settingsForm]="settingsForm"
                        [workflowBinding]="workflowBinding"
                        [formSubmissionTargets]="formSubmissionTargets"
                        (workflowBindingChange)="updateWorkflowBinding($event)"
                        (formSubmissionTargetChange)="selectFormSubmissionTarget($event)">
                    </app-function-general-settings>
                    <div class="action-buttons">
                        <button (click)="save()" [disabled]="disableSave()" color="primary"
                                mat-raised-button>
                            {{ isSaving ? 'Saving...' : 'Save' }}
                        </button>
                        <button (click)="delete()" [disabled]="isDeleting" color="warn" mat-raised-button>
                            {{ isDeleting ? 'Deleting...' : 'Delete' }}
                        </button>
                    </div>
                </div>
            </mat-tab>
            <!-- Test Tab -->
            <mat-tab label="Test">
                <div class="tab-content">
                    <app-function-test [functionOption]="functionOption"></app-function-test>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    </div>
}
